import React from 'react';

type BilingualTextProps = {
  as?: 'p' | 'span' | 'div' | 'h1' | 'h2' | 'h3' | 'h4';
  className?: string;
  children: React.ReactNode;
};

/**
 * Renders mixed Persian/English with correct direction per line (dir=auto)
 * and IranYekan for readable Persian typography.
 */
export function BilingualText({ as = 'p', className, children }: BilingualTextProps) {
  const Tag = as;
  const classes = ['bilingual-text', className].filter(Boolean).join(' ');
  return (
    <Tag className={classes} dir="auto">
      {children}
    </Tag>
  );
}
